import { RouteLocationNormalizedLoaded } from "vue-router";

type Target = "_blank" | "_self";

/** Route responsible to control redirects that are not related with VueRouter's route.
 * Usually used in anchor tags. */
export class ExternalRoute {
  /** Path is a string that is used to redirect user to another page and should be used just with the target attribute when this one is equal _blank.
   * Path example: "https://decola.lince.com.br/admin#/dashboard"
   * @see target. */
  public path: string;

  /** Defines if the route's path should be open in the same app frame or in another page.
   * and should be used just with the path attribute.
   * @see path */
  public target: Target;

  constructor(path: string = "", target: Target = "_self") {
    this.path = path;
    this.target = target;
  }
}
/** This route class have a direct relationship whit VueRouter's route. */
export class InternalRoute {
  /** Represents the VueRouter's route's name.
   * @see RouteLocationNormalizedLoaded */
  public name: string;

  /** Represents the VueRouter's route's params object.
   * @see RouteLocationNormalizedLoaded */
  public params: Record<string, string | string[]>;

  constructor(name: string = "", params: {} = {}) {
    this.name = name;
    this.params = params;
  }
}

/** Class that defines the menu's items configuration. */
export class MenuItem {
  /** item's title that is displayed to the user. */
  public title: string;

  /** Is an icon that should represent the title. */
  public image: string;

  /** @see InternalRoute
   * @see ExternalRoute */
  public route: InternalRoute | ExternalRoute;

  constructor(
    title: string,
    image: string,
    route: InternalRoute | ExternalRoute
  ) {
    this.title = title;
    this.image = image;
    this.route = route;
  }
}
